import { useState } from 'react';
import styled from '@emotion/styled';
import type { SourceSnippet } from '@trinity/chat/types/extracted-answers.api';
import { BlockQuote } from '../presentation/BlockQuote';

const Container = styled.div`
  margin-top: 8px;
`;

const Toggle = styled.button`
  background: none;
  border: none;
  color: var(--hyperlink);
  cursor: pointer;
  font-size: 14px;
  padding: 0;
  &:hover {
    text-decoration: underline;
  }
`;

const SnippetList = styled.div`
  margin-top: 4px;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const SourceLink = styled.a`
  font-size: 13px;
  color: var(--hyperlink);
  display: block;
  margin-top: 4px;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;

type Props = {
  snippets: SourceSnippet[];
  transcriptId: number;
};

export function SourceSnippetPanel({ snippets, transcriptId }: Props): React.ReactElement | null {
  const [expanded, setExpanded] = useState(false);

  if (snippets.length === 0) return null;

  return (
    <Container>
      <Toggle onClick={() => setExpanded((v) => !v)}>
        {expanded ? 'Hide' : 'Show'} {snippets.length} source{snippets.length > 1 ? 's' : ''}
      </Toggle>
      {expanded && (
        <SnippetList>
          {snippets.map((s, i) => (
            <BlockQuote key={`${s.sourceId}-${i}`}>
              &ldquo;{s.sentence}&rdquo;
              {s.start != null && (
                <SourceLink
                  href={`/workspaces/transcripts/${transcriptId}?s=${s.start}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View in transcript
                </SourceLink>
              )}
            </BlockQuote>
          ))}
        </SnippetList>
      )}
    </Container>
  );
}
